/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderCredentialV2ValidationData
 */
export interface ProviderCredentialV2ValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    brandAndMarket?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    agency?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    provider?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    username?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    password?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    url?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    targetBranch?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    agencyId?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    agentName?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    agentPassword?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    pcc?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    subscriptionKey?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    target?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    b2BAPIUserEmailAddress?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    b2BAPIUserPassword?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    serviceUrl?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    clientId?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    clientSecret?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    authenticationUrl?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    accessGroup?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    shoppingUrl?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    shoppingClientId?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    shoppingClientSecret?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    shoppingServiceUrl?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    postShoppingUrl?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    postShoppingClientId?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    postShoppingClientSecret?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderCredentialV2ValidationData
     */
    postShoppingServiceUrl?: ValidationMessage;
}

export function ProviderCredentialV2ValidationDataFromJSON(json: any): ProviderCredentialV2ValidationData {
    return ProviderCredentialV2ValidationDataFromJSONTyped(json, false);
}

export function ProviderCredentialV2ValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderCredentialV2ValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : ValidationMessageFromJSON(json['brandAndMarket']),
        'agency': !exists(json, 'agency') ? undefined : ValidationMessageFromJSON(json['agency']),
        'provider': !exists(json, 'provider') ? undefined : ValidationMessageFromJSON(json['provider']),
        'username': !exists(json, 'username') ? undefined : ValidationMessageFromJSON(json['username']),
        'password': !exists(json, 'password') ? undefined : ValidationMessageFromJSON(json['password']),
        'url': !exists(json, 'url') ? undefined : ValidationMessageFromJSON(json['url']),
        'targetBranch': !exists(json, 'targetBranch') ? undefined : ValidationMessageFromJSON(json['targetBranch']),
        'agencyId': !exists(json, 'agencyId') ? undefined : ValidationMessageFromJSON(json['agencyId']),
        'agentName': !exists(json, 'agentName') ? undefined : ValidationMessageFromJSON(json['agentName']),
        'agentPassword': !exists(json, 'agentPassword') ? undefined : ValidationMessageFromJSON(json['agentPassword']),
        'pcc': !exists(json, 'pcc') ? undefined : ValidationMessageFromJSON(json['pcc']),
        'subscriptionKey': !exists(json, 'subscriptionKey') ? undefined : ValidationMessageFromJSON(json['subscriptionKey']),
        'target': !exists(json, 'target') ? undefined : ValidationMessageFromJSON(json['target']),
        'b2BAPIUserEmailAddress': !exists(json, 'b2BAPIUserEmailAddress') ? undefined : ValidationMessageFromJSON(json['b2BAPIUserEmailAddress']),
        'b2BAPIUserPassword': !exists(json, 'b2BAPIUserPassword') ? undefined : ValidationMessageFromJSON(json['b2BAPIUserPassword']),
        'serviceUrl': !exists(json, 'serviceUrl') ? undefined : ValidationMessageFromJSON(json['serviceUrl']),
        'clientId': !exists(json, 'clientId') ? undefined : ValidationMessageFromJSON(json['clientId']),
        'clientSecret': !exists(json, 'clientSecret') ? undefined : ValidationMessageFromJSON(json['clientSecret']),
        'authenticationUrl': !exists(json, 'authenticationUrl') ? undefined : ValidationMessageFromJSON(json['authenticationUrl']),
        'accessGroup': !exists(json, 'accessGroup') ? undefined : ValidationMessageFromJSON(json['accessGroup']),
        'shoppingUrl': !exists(json, 'shoppingUrl') ? undefined : ValidationMessageFromJSON(json['shoppingUrl']),
        'shoppingClientId': !exists(json, 'shoppingClientId') ? undefined : ValidationMessageFromJSON(json['shoppingClientId']),
        'shoppingClientSecret': !exists(json, 'shoppingClientSecret') ? undefined : ValidationMessageFromJSON(json['shoppingClientSecret']),
        'shoppingServiceUrl': !exists(json, 'shoppingServiceUrl') ? undefined : ValidationMessageFromJSON(json['shoppingServiceUrl']),
        'postShoppingUrl': !exists(json, 'postShoppingUrl') ? undefined : ValidationMessageFromJSON(json['postShoppingUrl']),
        'postShoppingClientId': !exists(json, 'postShoppingClientId') ? undefined : ValidationMessageFromJSON(json['postShoppingClientId']),
        'postShoppingClientSecret': !exists(json, 'postShoppingClientSecret') ? undefined : ValidationMessageFromJSON(json['postShoppingClientSecret']),
        'postShoppingServiceUrl': !exists(json, 'postShoppingServiceUrl') ? undefined : ValidationMessageFromJSON(json['postShoppingServiceUrl']),
    };
}

export function ProviderCredentialV2ValidationDataToJSON(value?: ProviderCredentialV2ValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarket': ValidationMessageToJSON(value.brandAndMarket),
        'agency': ValidationMessageToJSON(value.agency),
        'provider': ValidationMessageToJSON(value.provider),
        'username': ValidationMessageToJSON(value.username),
        'password': ValidationMessageToJSON(value.password),
        'url': ValidationMessageToJSON(value.url),
        'targetBranch': ValidationMessageToJSON(value.targetBranch),
        'agencyId': ValidationMessageToJSON(value.agencyId),
        'agentName': ValidationMessageToJSON(value.agentName),
        'agentPassword': ValidationMessageToJSON(value.agentPassword),
        'pcc': ValidationMessageToJSON(value.pcc),
        'subscriptionKey': ValidationMessageToJSON(value.subscriptionKey),
        'target': ValidationMessageToJSON(value.target),
        'b2BAPIUserEmailAddress': ValidationMessageToJSON(value.b2BAPIUserEmailAddress),
        'b2BAPIUserPassword': ValidationMessageToJSON(value.b2BAPIUserPassword),
        'serviceUrl': ValidationMessageToJSON(value.serviceUrl),
        'clientId': ValidationMessageToJSON(value.clientId),
        'clientSecret': ValidationMessageToJSON(value.clientSecret),
        'authenticationUrl': ValidationMessageToJSON(value.authenticationUrl),
        'accessGroup': ValidationMessageToJSON(value.accessGroup),
        'shoppingUrl': ValidationMessageToJSON(value.shoppingUrl),
        'shoppingClientId': ValidationMessageToJSON(value.shoppingClientId),
        'shoppingClientSecret': ValidationMessageToJSON(value.shoppingClientSecret),
        'shoppingServiceUrl': ValidationMessageToJSON(value.shoppingServiceUrl),
        'postShoppingUrl': ValidationMessageToJSON(value.postShoppingUrl),
        'postShoppingClientId': ValidationMessageToJSON(value.postShoppingClientId),
        'postShoppingClientSecret': ValidationMessageToJSON(value.postShoppingClientSecret),
        'postShoppingServiceUrl': ValidationMessageToJSON(value.postShoppingServiceUrl),
    };
}


